import { configureStore } from '@reduxjs/toolkit'
import { persistStore } from 'redux-persist'
import rootReducer from '../reducers'

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE']
      }
    }),
  devTools: process.env.NODE_ENV !== 'production' && {
    trace: true,
    traceLimit: 25,
    actionSanitizer: (action) => {
      // Don't log sensitive data
      if (action.type === 'USER_LOGIN_SUCCESS' && action.payload.token) {
        return {
          ...action,
          payload: {
            ...action.payload,
            token: '[REDACTED]'
          }
        }
      }
      return action
    }
  }
})

export const persistor = persistStore(store)

export default store